// Contents
import PageHero from "../pageHero/PageHero_Contact.jsx";
import React, { useRef, useState, useEffect } from "react";
import { l } from '../../lang/index.jsx';
import { supabase } from '../../utils/supabase.js';

export default function Contact({lang}) {
    const containerRef = useRef(null);
    const [contentMap, setContentMap] = useState(null);

    useEffect(() => {
        supabase
            .from('contact_content')
            .select('fr, en')
            .eq('key', 'contact-content')
            .single()
            .then(({ data }) => {
                if (data) setContentMap(data);
            });
    }, []);

    const content = contentMap?.[lang] || l('contact-content', lang) || '';

    // Transforme les balises <br/> et les sauts de ligne \n en éléments React <br />
    const renderContentWithBreaks = (text) => {
        if (!text) return null;
        // split on <br/> (with optional space) or on newlines
        const parts = text.split(/(?:<br\s*\/?>|\r?\n|\\n)/i);
        return parts.map((part, i) => (
            <React.Fragment key={i}>
                {part}
                {i < parts.length - 1 && <br />}
            </React.Fragment>
        ));
    };

    return (<>
        <PageHero lang={lang}/>

        <div key={lang} className="section section-contact" ref={containerRef}>
            <div className="section-contact-inner">
                <div className="contact-content">
                    <p  className="reveal-type paragraph big-text" data-bg-color="transparent" data-fg-color="#fcfbe9">
                        {renderContentWithBreaks(content)}
                    </p>
                </div>

                <div className="contact-links">
                    <div>
                        <div className='contact-list'>
                            <div className="contact-item">
                                <a className='contact-picto email' target='_blank' href="mailto:hecktor.gauthier@gmail.com" aria-label="Contact me by email">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24"><path fill="currentColor" d="M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6zm3.519 0L12 11.671L18.481 6H5.52zM20 7.329l-7.341 6.424a1 1 0 0 1-1.318 0L4 7.329V18h16V7.329z"/></svg>
                                </a>
                            </div>

                            <div className="contact-item">
                                <a className='contact-picto linkedin' target='_blank' href="https://www.linkedin.com/in/hector-gauthier-1474a7173/" aria-label="Contact me by LinkedIn">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 20 20"><path fill="currentColor" d="M2.5 18h3V6.9h-3V18zM4 2c-1 0-1.8.8-1.8 1.8S3 5.6 4 5.6s1.8-.8 1.8-1.8S5 2 4 2zm6.6 6.6V6.9h-3V18h3v-5.7c0-3.2 4.1-3.4 4.1 0V18h3v-6.8c0-5.4-5.7-5.2-7.1-2.6z"/></svg>
                                </a>
                            </div>

                            <div className="contact-item">
                                <a className='contact-picto discord' target='_blank' href="https://discordapp.com/users/238583139880927233" aria-label="Contact me by Discord">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24"><path fill="currentColor" d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515a.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0a12.64 12.64 0 0 0-.617-1.25a.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057a19.9 19.9 0 0 0 5.993 3.03a.078.078 0 0 0 .084-.028a14.09 14.09 0 0 0 1.226-1.994a.076.076 0 0 0-.041-.106a13.107 13.107 0 0 1-1.872-.892a.077.077 0 0 1-.008-.128a10.2 10.2 0 0 0 .372-.292a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127a12.299 12.299 0 0 1-1.873.892a.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028a19.839 19.839 0 0 0 6.002-3.03a.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.956-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.955-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.946 2.418-2.157 2.418Z"/></svg>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div className="contact-infos">
                            <div className="contact-item">
                                <a className='link-contact' href="tel:+15816816569" aria-label="Contact me by canadian phone">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24"><path fill="currentColor" d="M6.62 10.79c1.44 2.83 3.76 5.15 6.59 6.59l2.2-2.2c.28-.28.67-.36 1.02-.25c1.12.37 2.32.57 3.57.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57c.11.35.03.74-.25 1.02l-2.2 2.2Z"/></svg>
                                    +1 581 681-6569
                                </a>
                                <span className="phone-country">Canada</span>
                            </div>
                            <div className="contact-item">
                                <a className='link-contact' href="tel:+33646701240" aria-label="Contact me by french phone">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24"><path fill="currentColor" d="M6.62 10.79c1.44 2.83 3.76 5.15 6.59 6.59l2.2-2.2c.28-.28.67-.36 1.02-.25c1.12.37 2.32.57 3.57.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57c.11.35.03.74-.25 1.02l-2.2 2.2Z"/></svg>
                                    +33 6 46 70 12 40
                                </a>
                                <span className="phone-country">France</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
}